<template>
    <div class="p-5">
        <div class="row">
            <div class="w-100 text-center bg-light">
                <div v-for="category in categories" class="d-inline-block text-center p-3">
                    <input type="checkbox" :id="category.id" :value="category.id" v-model="activeFilters"><label class="ml-2">{{ category.name }}</label>
                </div>
            </div>
        </div>
        <div class="row">

            <div v-for="product in activeContents" class="c-widget-products col-12 col-md-6 col-xl-3 text-center" >

                <a v-bind:href="product.url" class="c-widget-products__image" v-bind:style="{ backgroundImage: 'url(' + product.image + ')' }"></a>

                <a v-bind:href="product.url" class="c-widget-products__title">
                    {{ product.name }}
                </a>
                <div href="#" class="c-widget-products__model">
                    {{ product.model }}
                </div>
                <div href="#" class="c-widget-products__price">
                    {{ product.price }}
                </div>
                <a v-on:click="getUrls(product.id)" data-toggle="modal" data-target="#modal-deliveries" class="btn o-custom-button-gradient pl-3 pr-3">
                    {{ 'messages.buy' | trans }}
                </a>

                <a v-bind:href="`#cotization`" class="btn o-custom-button-white  pl-3 pr-3" >
                    {{ 'messages.quote' | trans }}
                </a>

                <a v-bind:href="`#dealers`" class="btn o-custom-button-white pl-3 pr-3" >
                    {{ 'messages.dealers_web' | trans }}
                </a>

            </div>
        </div>

        <!--Modal-->
        <div class="modal fade" id="modal-deliveries" tabindex="-1" role="dialog" aria-labelledby="modal-deliveries-label" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modal-deliveries-label">{{ 'messages.stores_available' | trans }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="col-12 mb-3">

                            <div v-for="url in urls" class="row pt-3 pb-3">
                                <h6 class="col-8 mt-3">{{ url.name }}</h6>
                                <div v-if="url.link" class="col-4">
                                    <a v-bind:href="url.link" class="btn d-block o-custom-button-gradient-small mt-1 btn-sm" target="_blank">
                                        <span>{{ 'messages.buy' | trans }}</span>
                                        <i class="fa fa-shopping-cart"></i>
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ 'messages.close' | trans }}</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: ['promotionId'],
        created() {
            this.getCategories();
            this.getProducts();
        },
        data() {
            return {
                activeFilters: [],
                categories: [],
                products: [],
                urls: []
            }
        },
        computed: {
            activeContents(){
                let filters = this.activeFilters;

                if(filters.length){
                    return this.products.filter((product) => {
                        return this.compareArrays(product.categories, filters);
                    });
                }
                return this.products;
            }
        },

        methods: {
            compareArrays: function (values, filters) {
                var response = false;
                values.forEach(function(element){
                    if(filters.includes(element)){
                        response = true;
                    }
                });
                return response;
            },
            getCategories: function () {
                axios
                    .get(route('ajax.getCategoriesPromotion', this.promotionId))
                    .then(response => {
                        this.categories = response.data;
                    });
            },
            getProducts: function (search = null) {
                axios
                    .get(route('ajax.getProductsPromotion', this.promotionId))
                    .then(response => {
                        this.products = response.data;
                    });
            },
            getUrls: function (productId) {
                axios
                    .get(route('ajax.getProductsUrls', productId))
                    .then(response => {
                        this.urls = response.data;
                    });
            },
        }
    }
</script>
